import {useSearchParams} from 'react-router-dom';

const useEditorEnabled = () => {
  const [searchParams] = useSearchParams();
  const nav = searchParams.get('nav');
  const enabled = nav ? nav === 'editor' : true;
  return enabled;
};

export default useEditorEnabled;
